import clsx from 'clsx';
import { PlatformSection } from '@/common/components';
import { Platforms } from '@/common/constants';
import { usePlatform } from '@/common/hooks';
import { TeamsTable, TeamsTableLegend } from '@/ui/components';

import { PrematchTableType } from '../../constants';
import { usePrematchData } from '../../hooks';
import { mapTableRowsToRowData } from '../../utils/mapTableRowsToRowData';

export default function GroupsView() {
  const { table } = usePrematchData();
  const platform = usePlatform();

  if (
    !table ||
    table.type !== PrematchTableType.GROUP_TABLE ||
    !table.groups ||
    !table.colorLegend
  ) {
    return null;
  }

  return (
    <div
      className={clsx('flex flex-col', {
        'pt-6 px-3 pb-3 gap-3': platform === Platforms.MOBILE,
        'pt-3 gap-2': platform !== Platforms.MOBILE,
      })}
    >
      {table.groups.map((group) => (
        <PlatformSection key={group.groupName} name={group.groupName} contentClassName="px-0 pb-0">
          <TeamsTable rowData={mapTableRowsToRowData(group.tableRows)} />
        </PlatformSection>
      ))}
      <TeamsTableLegend className="p-2" items={table.colorLegend} />
    </div>
  );
}
